(() => {
  if (typeof window.RealmLocalization?.initialize === 'function') return;
  const active = new Map();
  function initialize(scope = document) {
    for (const [dialog, controller] of active) if (dialog.isConnected === false) controller.destroy();
    const dialogs = Array.from(scope.querySelectorAll?.('[data-realm-localization]') || []);
    if (scope.matches?.('[data-realm-localization]')) dialogs.unshift(scope);
    for (const dialog of dialogs) {
      if (active.has(dialog)) continue;
      dialog.dataset.localizationBound = 'true';
      let destroyed = false;
      const listeners = [];
      function listen(target, type, handler, options) {
        if (!target) return;
        target.addEventListener(type, handler, options);
        listeners.push(() => target.removeEventListener(type, handler, options));
      }
      const form = dialog.querySelector('form');
      const select = dialog.querySelector('[data-localization-country]');
      const selected = dialog.querySelector('[data-localization-selected]');
      const change = dialog.querySelector('[data-localization-change]');
      const countries = dialog.querySelector('[data-localization-countries]');
      const search = dialog.querySelector('[data-localization-search]');
      const choices = Array.from(dialog.querySelectorAll('[data-localization-country-code]'));
      const groups = Array.from(dialog.querySelectorAll('[data-localization-group]'));
      const results = dialog.querySelector('[data-localization-results]');
      const submit = dialog.querySelector('[data-localization-submit]');
      const status = dialog.querySelector('[data-localization-status]');
      if (!form || !submit || !status) { delete dialog.dataset.localizationBound; continue; }
      let submitting = false;
      let generation = 0;
      const resetSubmission = () => { if (destroyed) return; generation++; submitting = false; submit.disabled = false; submit.removeAttribute('aria-busy'); form.removeAttribute('aria-busy'); status.textContent = ''; syncOpeners(); };
      const syncOpeners = () => {
        for (const opener of document.querySelectorAll('[data-dialog-open="' + dialog.id + '"]')) opener.setAttribute('aria-expanded', String(dialog.open));
      };
      const observer = new MutationObserver(syncOpeners);
      observer.observe(dialog, { attributes: true, attributeFilter: ['open'] });
      syncOpeners();
      if (select && selected && change && countries && search) {
        select.hidden = true;
        selected.hidden = false;
        const filter = () => {
          const query = search.value.trim().normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase();
          const matches = new Set();
          for (const choice of choices) {
            const text = (choice.dataset.localizationCountryLabel + ' ' + choice.dataset.localizationCountryCode).normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase();
            choice.hidden = !text.includes(query);
            if (!choice.hidden) matches.add(choice.dataset.localizationCountryCode);
          }
          for (const group of groups) group.hidden = !Array.from(group.querySelectorAll('[data-localization-country-code]')).some(choice => !choice.hidden);
          dialog.querySelector('[data-localization-empty]').hidden = matches.size !== 0;
          if (results) results.textContent = query && matches.size ? results.dataset.resultsLabel.replace('__count__', String(matches.size)) : '';
        };
        const setDisclosure = (open, focus = false) => {
          countries.hidden = !open;
          change.setAttribute('aria-expanded', String(open));
          if (open) { search.value = ''; filter(); if (focus) search.focus({ preventScroll: true }); }
          else if (focus) change.focus({ preventScroll: true });
        };
        const syncSelection = () => {
          const selectedChoice = choices.find(choice => choice.dataset.localizationCountryCode === select.value);
          if (selectedChoice) dialog.querySelector('[data-localization-country-name]').textContent = selectedChoice.dataset.localizationCountryLabel;
          for (const choice of choices) choice.setAttribute('aria-pressed', String(choice.dataset.localizationCountryCode === select.value));
        };
        listen(change, 'click', () => setDisclosure(countries.hidden, true));
        listen(search, 'input', filter);
        listen(countries, 'click', event => {
          const choice = event.target.closest('[data-localization-country-code]');
          if (!choice || !countries.contains(choice)) return;
          const code = choice.dataset.localizationCountryCode;
          if (!Array.from(select.options).some(option => option.value === code)) return;
          select.value = code;
          select.dispatchEvent(new Event('change', { bubbles: true }));
          syncSelection();
          setDisclosure(false, true);
        });
        listen(dialog, 'close', () => { if (!submitting) form.reset(); syncSelection(); setDisclosure(false); });
      }
      listen(form, 'submit', event => {
        if (submitting) { event.preventDefault(); return; }
        if (event.defaultPrevented || !form.checkValidity()) return;
        const destination = new URL(window.location.href);
        const product = document.getElementById('MainContent')?.querySelector('[data-realm-product]');
        const variant = product?.querySelector('[data-product-form] input[name="id"]');
        const gallery = product?.querySelector('[data-realm-gallery]');
        const onProductPage = /\/products\/[^/]+\/?$/.test(destination.pathname);
        if (onProductPage && gallery?.dataset.galleryProductId && variant && /^[1-9]\d*$/.test(variant.value || '')) destination.searchParams.set('variant', variant.value);
        const returnTo = destination.pathname + destination.search + destination.hash;
        let fields = Array.from(form.querySelectorAll('input[name="return_to"]'));
        if (!fields.length) { const field = document.createElement('input'); field.type = 'hidden'; field.name = 'return_to'; form.append(field); fields = [field]; }
        for (const field of fields) field.value = returnTo;
        submitting = true;
        const submission = ++generation;
        window.queueMicrotask(() => {
          if (destroyed || submission !== generation || form.isConnected === false) return;
          if (event.defaultPrevented) { resetSubmission(); return; }
          submit.disabled = true;
          submit.setAttribute('aria-busy', 'true');
          form.setAttribute('aria-busy', 'true');
          status.textContent = status.dataset.submittingLabel;
        });
      });
      listen(window, 'pageshow', resetSubmission);
      listen(dialog, 'click', event => {
        if (event.target !== dialog) return;
        const bounds = dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.querySelector('[data-dialog-close]').click();
      });
      active.set(dialog, { destroy() {
        generation++;
        destroyed = true;
        observer.disconnect();
        listeners.splice(0).forEach(remove => remove());
        for (const opener of document.querySelectorAll('[data-dialog-open="' + dialog.id + '"]')) opener.setAttribute('aria-expanded', 'false');
        delete dialog.dataset.localizationBound;
        active.delete(dialog);
      } });
    }
  }
  const ready = () => initialize();
  const load = event => initialize(event.target);
  const unload = event => { for (const [dialog, controller] of active) if (event.target === dialog || event.target.contains(dialog)) controller.destroy(); };
  window.RealmLocalization = { initialize, destroy() {
    for (const controller of Array.from(active.values())) controller.destroy();
    document.removeEventListener('DOMContentLoaded', ready);
    document.removeEventListener('shopify:section:load', load);
    document.removeEventListener('shopify:section:unload', unload);
    delete window.RealmLocalization;
  } };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready, { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', load);
  document.addEventListener('shopify:section:unload', unload);
})();
